export default __webpack_public_path__ + "static/media/pic1.2a2a16f8.svg";